















































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import { Letter } from '@/store/models/Letter/Letter';
import LetterTrailTreeMobile from '@/components/MobileComponents/LetterDetailsMobile/LetterTrailMobile/LetterTrailTreeMobile.vue';
import { saveFile, converBase64toBlob, getPersianDate } from '@/util/utils';
import * as fileService from '@/store/Services/fileService';
import * as $ from 'jquery';
import {FoldersTreeNodeData} from '@/components/Cartable/FoldersTree/FoldersTreeNode/FoldersTreeNode.vue';
import FoldersTreeNodeMobile from '@/components/MobileComponents/FoldersTreeMobile/FoldersTreeNodeMobile/FoldersTreeNodeMobile.vue';
import { OwnerFolder } from '@/store/models/LetterOwner/OwnerFolder';
import * as letterOwnerService from '@/store/Services/letterOwnerService.ts';
import * as letterService from '@/store/Services/letterServices.ts';
import * as autoCompleteDataService from '@/store/Services/autoCompleteDataService.ts';
import AttachmentEditorMobile from '@/components/MobileComponents/AttachmentEditorMobile/AttachmentEditorMobile.vue';

import store from '@/store';
import { AutoCompleteData } from '@/store/models/Letter/AutoCompleteData';
@Component({
    components: {LetterTrailTreeMobile, FoldersTreeNodeMobile, AttachmentEditorMobile}
})
export default class FinalizeLetterMobile extends Vue{
@Prop() letter?: Letter
isReceived = true;
isLoading= false;
@Watch("letter")
onLetterChanged(newVal: Letter, oldVal: Letter){
        this.setIsReceived();
}
created(){
        this.setIsReceived();
}
get letterTime(){
        if(this.letter === undefined) return '';
        const date = new Date( this.letter.sendTime);
        date.setMinutes(date.getMinutes() - 270);
        return (date).toLocaleTimeString();
}

 setIsReceived(){
        this.isReceived = false;
        if(this.letter == undefined)return;
        if(this.letter.recievers === null)
            this.isReceived = true;
    }
   async downloadLetterPdf(){
        if(this.letter === undefined)return;
        if(this.letter.parts === undefined || this.letter.parts === null)return;
        const file = await fileService.getFile(this.letter.parts[0].file.id);
        const blob =  converBase64toBlob(file.content||"",'');
        saveFile(blob,file.extension);
    }
    autoCompleteData: AutoCompleteData[] = [];
    comment = "";
    async mounted(){
        this.autoCompleteData =  await autoCompleteDataService.getCloseAutoCompleteData();

        $('.ui.dropdown').dropdown({ action: 'nothing'  });
        this.loadArchiveFolders(); 
    }

    async loadArchiveFolders(){
        const archiveFolders =  await letterOwnerService.getArchiveFolders(store.state.ownerId);
        archiveFolders.forEach((folder,index)=>{
            const archiveFoldersNode = {} as FoldersTreeNodeData;
            archiveFoldersNode.name = folder.name;
            archiveFoldersNode.isRoot = true;
            archiveFoldersNode.url = folder.id;
            archiveFoldersNode.iconClass = {'icon-folder1':true,'fixed-icon':true }
            archiveFoldersNode.children = [];
            if(folder.childFolders !== undefined && folder.childFolders !== null)
                this.addArchiveFolder(archiveFoldersNode,folder.childFolders);
            this.folders.push(archiveFoldersNode);
        });
        
    }
    onCommentSelected(){
        const data =  this.autoCompleteData.find(item=>item.name === this.comment.trim());
        let autoCompleteDataId = '';
        if(data){
            autoCompleteDataId = data.id;
        }
    }
    addArchiveFolder(parent: FoldersTreeNodeData, archiveFolders: OwnerFolder[]){
        archiveFolders.forEach(folder=>{
            const childNode = {} as FoldersTreeNodeData;
            childNode.name = folder.name;
            childNode.isRoot = true;
            childNode.iconClass = {'icon-folder':true,'fixed-icon':true};
            childNode.url = folder.id;
            childNode.children = [];
            parent.children.push(childNode);
            if(folder.childFolders !== null && folder.childFolders != undefined)
                this.addArchiveFolder(childNode,folder.childFolders);
        });
    }
    folders: FoldersTreeNodeData[] = [];
    close(){
        store.state.eventHub.$emit('close-finalizeLetter')
    }
    async finalize(){
        if(this.letter){
            try {
                this.isLoading=true;
                await letterService.CloseLetter(this.letter.letterPossessionId,this.comment,this.selectedFolderIds);    
            } catch (error) {
                console.log(error)    
            }finally{
                this.isLoading=false;
                
                store.state.eventHub.$emit('close-finalizeLetter',this.letter.letterPossessionId)
            }
        }
    }

    onFolderSelectedChanged(selection: any){
        if(selection.isSelected)
        {
            this.selectedFolderIds.push(selection.id);
        }
        else{
            const index =  this.selectedFolderIds.indexOf(selection.id);
            this.selectedFolderIds.splice(index,1);
        }
    }

    selectedFolderIds: string[] = [];
}
